// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crypto-textArea {
  max-height: 34.1vw;
  margin: 0 2vw;
  border: solid 0.1vw;
  font-size: 2vw;
  padding: 0.8vw;
  overflow-y: scroll;
  box-shadow:
    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),
    0 0.3vw 1vw rgba(0, 0, 0, 0.08);
  resize: none;
  background: rgb(227, 241, 250);
}
.crypto-Area {
  display: grid;
  grid-template-rows: 2.2vw 1fr;
  gap: 1vw;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Сrypto/styles/CryptoTextArea.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB;;mCAEiC;EACjC,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,QAAQ;AACV","sourcesContent":[".crypto-textArea {\n  max-height: 34.1vw;\n  margin: 0 2vw;\n  border: solid 0.1vw;\n  font-size: 2vw;\n  padding: 0.8vw;\n  overflow-y: scroll;\n  box-shadow:\n    0 0.2vw 0.4vw rgba(0, 0, 0, 0.12),\n    0 0.3vw 1vw rgba(0, 0, 0, 0.08);\n  resize: none;\n  background: rgb(227, 241, 250);\n}\n.crypto-Area {\n  display: grid;\n  grid-template-rows: 2.2vw 1fr;\n  gap: 1vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
